import { render, staticRenderFns } from "./CaregiverHistory.vue?vue&type=template&id=8a2447c4&scoped=true"
import script from "./CaregiverHistory.vue?vue&type=script&lang=js"
export * from "./CaregiverHistory.vue?vue&type=script&lang=js"
import style0 from "./CaregiverHistory.vue?vue&type=style&index=0&id=8a2447c4&prod&lang=scss"
import style1 from "./CaregiverHistory.vue?vue&type=style&index=1&id=8a2447c4&prod&lang=scss&scoped=true"
import style2 from "./CaregiverHistory.vue?vue&type=style&index=2&id=8a2447c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2447c4",
  null
  
)

export default component.exports